<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div class="text-xs-center">
		<v-dialog
			v-model="modal"
			width="500">
			<template v-slot:activator="{ on }">
				<v-btn
					color="lightred"
					dark
					v-on="on">
					Dodaj pole w grupie formularza
				</v-btn>
			</template>
			<v-card>
				<v-card-title
					class="headline blue white--text"
					primary-title
				>
					Dodanie pola do grupy
					{{ group.name }}
				</v-card-title>

				<v-card-text :key="componentKey" class="new-field">
					<span v-if="!newFieldType">Wybierz rodzaj pola</span>
					<v-flex>
						<v-select
							v-model="newFieldType"
							v-if="!newFieldType"
							:items="fieldTypesList"
							label="Rodzaj pola"
							aria-label="field type"
							for="add-field-modal-field-type"
							id="add-field-modal-field-type">
						</v-select>
					</v-flex>
					<v-flex>
						<div class="text-xs-center">
							<h4>{{newFieldType}}</h4>
						</div>

						<v-card v-if="isFieldType(fieldTypes.CHECKBOX)">
							<checkboxProps v-model="fieldsProps.checkbox"/>
						</v-card>
						<v-card v-if="isFieldType(fieldTypes.PERMANENT_TEXT)">
							<PermanentTextFieldsProps v-model="fieldsProps.permanentText"/>
						</v-card>
						<v-card v-if="isFieldType(fieldTypes.TEXT)">
							<TextFieldProps v-model="fieldsProps.text"/>
						</v-card>
						<v-card v-if="isFieldType(fieldTypes.TEXTAREA)">
							<TextFieldProps v-model="fieldsProps.textArea"/>
						</v-card>
						<v-card v-if="isFieldType(fieldTypes.NUMBER)">
							<NumberFieldProps v-model="fieldsProps.number"/>
						</v-card>
						<v-card v-if="isFieldType(fieldTypes.DATE)">
							<DateFieldProps v-model="fieldsProps.date"/>
						</v-card>
						<v-card v-if="isFieldType(fieldTypes.LIST_ONE_CHOICE)">
							<ListOneChoiceFiledProps v-model="fieldsProps.listOneChoice" v-bind:edit="edit"/>
						</v-card>
						<v-card v-if="isFieldType(fieldTypes.RADIO_LIST_ONE_CHOICE)">
							<ListOneChoiceFiledProps v-model="fieldsProps.radioListOneChoice" v-bind:edit="edit"/>
						</v-card>
						<v-card v-if="isFieldType(fieldTypes.RADIO_LIST_MULTI_CHOICE)">
							<ListMultiChoiceProps v-model="fieldsProps.radioListMultiChoice" v-bind:edit="edit"/>
						</v-card>
						<v-card v-if="isFieldType(fieldTypes.CHECKBOX_LIST_MULTI_CHOICE)">
							<ListMultiChoiceProps v-model="fieldsProps.checkboxListMultiChoice" v-bind:edit="edit"/>
						</v-card>
						<v-card v-if="isFieldType(fieldTypes.ATTACHMENT)" v-bind:edit="edit">
							<AttachmentFieldProps v-model="fieldsProps.attachment"/>
						</v-card>
						<v-card
							v-if="isFieldType(fieldTypes.CONDITIONAL) && ((groupDoesntContainConditional() && groupIsNotFinal()) || edit)">
							<ConditionalFieldProps v-model="fieldsProps.conditional" v-bind:edit="edit"/>
						</v-card>
						<v-card
							v-if="isFieldType(fieldTypes.CONDITIONAL) && (!groupIsNotFinal() || !groupDoesntContainConditional)">
							Uwaga: Dodawanie pól w grupach, które zostały utworzone dodając pole warunkujące jest
							niedopuszczalne.
						</v-card>
						<v-card v-if="isFieldType(fieldTypes.TABLE)">
							<TableFieldProps v-model="fieldsProps.table"/>
						</v-card>
					</v-flex>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn v-if="!edit && !(fieldsProps.permanentText.value.length > 32767 || fieldsProps.text.max > 32767 || fieldsProps.textArea.max > 32767)"
						color="primary"
						@click="addNewField"
					>
						Dodaj
					</v-btn>
					<v-btn v-if="edit"
						color="primary"
						@click="saveEditedField">
						Zapisz
					</v-btn>
					<v-btn
						color="blue"
						@click="closeModal">
						Zamknij
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import TextFieldProps from "./field_props/textFieldProps";
	import PermanentTextFieldsProps from "./field_props/permanentTextFieldProps";
	import NumberFieldProps from "./field_props/numberFieldProps";
	import DateFieldProps from "./field_props/dateFieldProps";
	import ListOneChoiceFiledProps from "./field_props/listOneChoiceProps";
	import ListMultiChoiceProps from "./field_props/listMultiChoiceProps";
	import AttachmentFieldProps from "./field_props/attachmentFieldProps";
	import {fieldTypes} from "@/utils/FieldTypes";
	import ConditionalFieldProps from "./field_props/conditionalFieldProps";
	import checkboxProps from "./field_props/checkboxProps";
	import TableFieldProps from "./field_props/tableFieldProps";
	import {genericFormUtil} from "@/utils/genericFormUtil";

	export default {
		name: "AddFieldModal",

		components: {
			checkboxProps, ConditionalFieldProps, AttachmentFieldProps, ListOneChoiceFiledProps,
			DateFieldProps, NumberFieldProps, PermanentTextFieldsProps, TextFieldProps, ListMultiChoiceProps,
			TableFieldProps,
		},

		computed: {
			group: function () {
				return this.form.formSchema.sections[this.form.selected.sectionIndex].groups[this.form.selected.groupIndex];
			},

			section: function () {
				return this.form.formSchema.sections[this.form.selected.sectionIndex];
			},
		},

		methods: {

			editField(indexes) {
				this.modal = true;
				this.edit = true;
				this.editIndex = indexes.fieldIndex;
				let editedFieldProp = this.group.fields[indexes.fieldIndex];
				this.newFieldType = fieldTypes.getPolishNameByBusinessName(editedFieldProp.business);
				this.assignPropToDataProp(editedFieldProp);
			},

			groupDoesntContainConditional() {
				let field = this.group.fields.find(field => {
					return field.business === fieldTypes.CONDITIONAL;
				});
				return field === undefined;
			},

			groupIsNotFinal() {
				return !this.group.final;
			},

			assignPropToDataProp(editedFieldProp) {
				let prop = this.findPropOfType(editedFieldProp.business);
				Object.assign(prop, editedFieldProp);
			},

			// ta metoda przywraca obiekt data do poczatkowej wartosci, czysci ona modal dodawania pola
			resetData() {
				Object.assign(this.$data, this.$options.data.call(this));
			},

			isFieldType(fieldType) {
				return fieldType === fieldTypes.getBusinessNameByPolishName(this.newFieldType);
			},

			saveEditedField() {
				this.assignEditedFieldToArray(this.group.fields, this.editIndex, fieldTypes.getBusinessNameByPolishName(this.newFieldType));
				this.modal = false;
				this.clearModal();
				this.$emit("updateFieldList");
			},

			addNewField() {
				if (this.isFieldType(fieldTypes.CONDITIONAL) && !(this.groupDoesntContainConditional() && this.groupIsNotFinal())) {
					this.$messagesBus.$emit("error", "Pole warunkujące nie może zostać dodane do tej grupy!");
					return;
				}
				this.assignFieldToArray(this.group.fields, fieldTypes.getBusinessNameByPolishName(this.newFieldType));
				// dodajemy dwie grupy które sa renderowane zaleznie od wartosci bool
				if (this.newFieldType === fieldTypes.getPolishNameByBusinessName(fieldTypes.CONDITIONAL)) {
					let prop = this.findPropOfType(fieldTypes.CONDITIONAL);
					this.assignNewFinalGroups(prop.groupOn, prop.groupOff);
				}
				this.modal = false;
				this.clearModal();
			},

			assignNewFinalGroups(groupOnName, groupOffName) {
				let groupOn = {
					name: groupOnName,
					fields: [],
					final: true,
				};
				let groupOff = {
					name: groupOffName,
					fields: [],
					final: true,
				};
				this.section.groups.splice(this.form.selected.groupIndex + 1, 0, groupOn, groupOff);
			},

			closeModal() {
				this.modal = false;
				this.clearModal();
			},

			clearModal() {
				this.resetData();
			},

			assignFieldToArray(array, businessFieldType) {
				let fieldProp = this.findPropOfType(businessFieldType);
				fieldProp.id = genericFormUtil.generateIdForField();
				array.push(Object.assign({}, fieldProp));
			},

			assignEditedFieldToArray(array, index, businessFieldType) {
				let fieldProp = this.findPropOfType(businessFieldType);
				array[index] = Object.assign({}, fieldProp);
			},

			findPropOfType(businessFieldType) {
				let props = Object.values(this.fieldsProps);
				return props.find(prop => prop.business === businessFieldType);
			},
		},

		props: {
			value: Object,
		},

		watch: {
			form: {
				handler() {
					this.$emit("input", this.form);
				}
				,
				deep: true,
			},
		},

		data() {
			return {
				edit: false,

				editIndex: -1,

				form: this.value,

				modal: false,

				componentKey: 0,

				newFieldType: "",

				fieldTypes: fieldTypes,

				fieldTypesList: fieldTypes.getAllPolishNames(),

				fieldsProps: {
					checkbox: {
						label: "",
						id: "",
						hint: "",
						required: false,
						business: fieldTypes.CHECKBOX,
						view: true
					},
					permanentText: {
						label: "",
						id: "",
						value: "",
						type: "text",
						business: fieldTypes.PERMANENT_TEXT,
						view: true
					},

					text: {
						label: "",
						id: "",
						hint: "",
						type: "input",
						required: false,
						min: 0,
						max: undefined,
						business: fieldTypes.TEXT,
						view: true
					},

					textArea: {
						label: "",
						id: "",
						hint: "",
						type: "input",
						required: false,
						min: 0,
						max: undefined,
						business: fieldTypes.TEXTAREA,
						view: true
					},

					number: {
						label: "",
						id: "",
						hint: "",
						type: "number",
						required: false,
						min: 0,
						max: undefined,
						business: fieldTypes.NUMBER,
						view: true
					},
					date: {
						label: "",
						id: "",
						hint: "",
						required: false,
						min: "",
						max: "",
						business: fieldTypes.DATE,
						view: true
					},
					listOneChoice: {
						label: "",
						id: "",
						hint: "",
						required: true,
						options: [],
						business: fieldTypes.LIST_ONE_CHOICE,
						view: true
					},
					radioListOneChoice: {
						label: "",
						id: "",
						hint: "",
						required: false,
						options: [],
						business: fieldTypes.RADIO_LIST_ONE_CHOICE,
						view: true
					},

					radioListMultiChoice: {
						name: "",
						id: "",
						label: "",
						hint: "",
						required: false,
						options: [],
						business: fieldTypes.RADIO_LIST_MULTI_CHOICE,
						view: true
					},

					checkboxListMultiChoice: {
						name: "",
						id: "",
						label: "",
						hint: "",
						required: false,
						options: [],
						business: fieldTypes.CHECKBOX_LIST_MULTI_CHOICE,
						view: true
					},

					attachment: {
						id: "",
						label: "",
						hint: "",
						required: false,
						link: null,
						business: fieldTypes.ATTACHMENT,
						view: true
					},

					conditional: {
						id: "",
						label: "",
						hint: "",
						multi: true,
						textOn: "Tak",
						textOff: "Nie",
						value: false,
						groupOn: "",
						groupOff: "",
						business: fieldTypes.CONDITIONAL,
						view: true
					},

					table: {
						label: "",
						hint: "",
						maxRows: 10,
						minRows: 1,
						columns: [{ title: 'Kolumna 1' }],
						business: fieldTypes.TABLE,
						view: true
					},
				},
			};
		},
	};
</script>

<style scoped>
		.theme--dark .red.lighten-2 {
		color: #000;
	}
</style>
